import { Component, Input, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { Subject, takeUntil, debounceTime, distinctUntilChanged } from 'rxjs';
import { SubscriberService } from 'src/app/services/manager/subscriber.service';
import { ModalController } from '@ionic/angular';
import { ModalService } from 'src/app/services/base/modal.service';
import { ConvertContactComponent } from '../convert-contact/convert-contact.component';
import { LoginService } from 'src/app/services/auth/login.service';
import { CoreService } from 'src/app/services/manager/core.service';

@Component({
  selector: 'app-lexware-contact',
  templateUrl: './lexware-contact.component.html',
  styleUrls: ['./lexware-contact.component.scss'],
  standalone: false,
})
export class LexwareContactComponent implements OnInit, OnDestroy {

  @Input() search = "";
  @Input() showSearch = true;
  @Input() data: any; // Input für die übergebenen Daten
  mode: number = 0;

  destroy = new Subject();

  private searchSubject = new Subject<string>();

  searchTerm = '';

  dataList: any;
  dataListFiltered: any;

  constructor(
    private modalCtrl: ModalController,
    private sub: SubscriberService,
    private modal: ModalService,
    private loginService: LoginService,
    private core: CoreService
  ) {}

  ngOnInit() {
    this.mode = this.data || 0

    this.searchSubject.pipe(
      takeUntil(this.destroy),
      debounceTime(250),
      distinctUntilChanged()
    ).subscribe(term => {
      this.searchTerm = term;
      this.filterProducts();
    });

    this.subscribe();
    this.loginService.checkLoginStatus();

    // Diese Komponente zeigt nur an, was in sub.lexwareContactList liegt — sie loest
    // selbst keinen Ladevorgang aus. Beim App-Login wird die Liste nicht mehr automatisch
    // geladen (vermeidet den Session-Alert), daher hier bei Bedarf nachholen.
    if ((this.sub.lexwareContactList.getValue() || []).length === 0) {
      this.core.loadLexwareContacts();
    }
  }

  subscribe() {
    this.sub.lexwareContactList
      .pipe(takeUntil(this.destroy))
      .subscribe((data) => {
        this.dataList = data;
        console.log(this.dataList);
        this.filterProducts();
      });
  }

      ngOnChanges(changes: SimpleChanges) {
        if (changes['search']) {
          this.handleDataChange(changes['search'].currentValue);
        }
      }

      handleDataChange(newValue: string) {
          this.searchSubject.next(newValue);
      }

  onSearchChange(event: any) {
    const inputValue = event.target.value;
    this.searchSubject.next(inputValue);
  }

  filterProducts() {
    if(this.dataList == null || this.dataList == undefined) {
      return;
    }

    if (this.searchTerm) {
      const searchTermLower = this.searchTerm.toLowerCase();
      this.dataListFiltered = this.dataList.filter((item: any) => {
        // Search in main fields
        if (item.companyName && item.companyName.toLowerCase().includes(searchTermLower)) {
          return true;
        }
        if (item.email && item.email.toLowerCase().includes(searchTermLower)) {
          return true;
        }
        if (item.phone && item.phone.toLowerCase().includes(searchTermLower)) {
          return true;
        }
        if (item.website && item.website.toLowerCase().includes(searchTermLower)) {
          return true;
        }

        // Search in address fields
        if (item.address) {
          if (item.address.street && item.address.street.toLowerCase().includes(searchTermLower)) {
            return true;
          }
          if (item.address.city && item.address.city.toLowerCase().includes(searchTermLower)) {
            return true;
          }
          if (item.address.zip && item.address.zip.toLowerCase().includes(searchTermLower)) {
            return true;
          }
        }

        // Search in contact person fields
        if (item.contactPerson) {
          if (item.contactPerson.firstName && item.contactPerson.firstName.toLowerCase().includes(searchTermLower)) {
            return true;
          }
          if (item.contactPerson.lastName && item.contactPerson.lastName.toLowerCase().includes(searchTermLower)) {
            return true;
          }
          if (item.contactPerson.emailAddress && item.contactPerson.emailAddress.toLowerCase().includes(searchTermLower)) {
            return true;
          }
          if (item.contactPerson.phoneNumber && item.contactPerson.phoneNumber.toLowerCase().includes(searchTermLower)) {
            return true;
          }
        }

        return false;
      });
    } else {
      this.dataListFiltered = this.dataList;
    }
  }

  trackByContactId(index: number, item: any): string {
    return item?.id || item?.email || item?.companyName || index.toString();
  }

  selectContact(contact: any) {
    this.sendBackData(contact);
  }

  sendBackData(data: any = null) {
    if(this.mode == 1) {
      this.modalCtrl.dismiss(data);
    }else {
      this.modal.openModal(ConvertContactComponent, data);
    }
  }

  /**
   * Check if a contact belongs to another owner
   * @param contact The contact to check
   * @returns true if the contact belongs to another owner
   */
  isFromAnotherOwner(contact: any): boolean {
    // If we don't have a logged in user or the contact doesn't have an owner, return false
    if (!this.loginService.decodedToken || !contact.owner) {
      return false;
    }

    // Compare the current user's email with the contact's owner
    const currentUserEmail = this.loginService.decodedToken.email;
    return contact.owner && contact.owner.email !== currentUserEmail;
  }

  /**
   * Check if the current user is an admin
   * @returns true if the user is an admin
   */
  isAdmin(): boolean {
    return this.loginService.decodedToken?.role === 'admin';
  }

  async newContact() {
    try {
      const modal = await this.modalCtrl.create({
        component: ConvertContactComponent,
        componentProps: {
          data: { google: null, lexware: null }
        },
        cssClass: 'modal-full'
      });
      
      await modal.present();
      
      const { data } = await modal.onDidDismiss();
      if (data) {
        // Handle the returned data if needed
        console.log('Modal returned data:', data);
      }
    } catch (error) {
      console.error('Error opening modal:', error);
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }
  ngOnDestroy() {
    this.destroy.next(true);
    this.destroy.complete();
  }

}
